import { createSlice } from '@reduxjs/toolkit';

import { LibraryUpdatesModalStore } from './typings';

const initialState: LibraryUpdatesModalStore = {
    modalWasClosed: false,
};

// Параметры нужны для саги
/* eslint-disable @typescript-eslint/no-unused-vars */
const slice = createSlice({
    name: 'LAB.LIBRARY_UPDATES_MODAL',
    initialState: initialState,
    reducers: {
        closeModal: (state) => {
            state.modalWasClosed = true;
        },
    },
});
/* eslint-enable @typescript-eslint/no-unused-vars */

export const actions = slice.actions;
export const reducer = slice.reducer;
